import React, { useState, useCallback, useRef, useEffect } from "react";
import axios from "axios";
import "./provdocumentation.css";
import Swal from "sweetalert2";
import { TbCloudUpload } from "react-icons/tb";
import { FaTrash } from "react-icons/fa6";
import { getTokenCookie } from "../../views/Login/cookie";

const Provdocumentation = () => {
  const [DNI, setDNI] = useState(null);
  const [MonotaxCertificate, setMonotaxCertificate] = useState(null);
  const [CBUCertificate, setCBUCertificate] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [load, setLoad] = useState(true);
  const [type, setType] = useState("");
  const [data, setData] = useState("");

  useEffect(() => {
    async function fetchData() {
      const token = getTokenCookie();
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_GET_SUPPLIER}${token}`
        );
        setData(response.data);
        setType(response.data.SupplierType.type);
        setLoad(false);
      } catch (error) {
        setLoad(false);
      }
    }

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const inputRefs = {
    DNI: useRef(null),
    MonotaxCertificate: useRef(null),
    CBUCertificate: useRef(null),
  };

  const handleFileChange = useCallback((event, setter) => {
    const file = event.target.files[0];
    if (file && file.size > 500 * 1024) {
      // 500 KB
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "El archivo excede el tamaño máximo permitido (500 KB).",
      });
    } else {
      setter(file);
    }
  }, []);

  const removeFile = (setter) => {
    setter(null);
  };

  const handleUpload = async () => {
    setIsUploading(true);

    if (!DNI || !MonotaxCertificate || !CBUCertificate) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Por favor, seleccione todos los archivos antes de subirlos.",
      });
      setIsUploading(false);
      return;
    }

    const formData = new FormData();
    formData.append("document", DNI, "DNI." + DNI.type.split("/")[1]);
    formData.append(
      "document",
      MonotaxCertificate,
      "ConstanciaMonotributo." + MonotaxCertificate.type.split("/")[1]
    );
    formData.append(
      "document",
      CBUCertificate,
      "ConstanciaCBU." + CBUCertificate.type.split("/")[1]
    );
    formData.append("supplierId", data.id);

    try {
      let response;
      if (type === "Persona Humana") {
        response = await axios.post(
          `${process.env.REACT_APP_DOCUMENT_SUPPLIER}`,
          formData
        );
      } else {
        response = await axios.post(
          `${process.env.REACT_APP_DOCUMENT_SUPPLIER_COMPANY}`,
          formData
        );
      }

      if (response.status === 201) {
        setDNI(null);
        setMonotaxCertificate(null);
        setCBUCertificate(null);

        setIsUploading(false);

        document.getElementById("DNI").value = "";
        document.getElementById("MonotaxCertificateInput").value = "";
        document.getElementById("CBUCertificateInput").value = "";

        Swal.fire({
          icon: "success",
          title: "Éxito",
          text:
            "Se ha subido sus documentos con éxito." || response.data.message,
        });
      }
    } catch (error) {
      setIsUploading(false);
    }
  };

  return (
    <>
      {!load ? (
        <div className="cardformprov">
          <p className="tittlebill">Mi Documentacion</p>

          <div className="boxbuttonsdispleyprevarchive">
            <div className="boxbuttonsdispleyprev">
              <div className="boxbuttonpersonprev">
                <input
                  type="file"
                  id="DNI"
                  ref={inputRefs.DNI}
                  onChange={(event) => handleFileChange(event, setDNI)}
                  style={{ display: "none" }}
                />

                <button
                  className="boxinputprevarchive"
                  onClick={() => inputRefs.DNI.current.click()}
                >
                  <TbCloudUpload className="iconbuttonarchiveprev" />
                  <span>DNI</span>
                </button>

                {DNI && (
                  <div className="namefiledprov">
                    <p className="buttonprevtextarchivedelete">{DNI.name}</p>
                    <button
                      className="buttondeletearchive"
                      onClick={() => removeFile(setDNI)}
                    >
                      <FaTrash />
                    </button>
                  </div>
                )}
              </div>
            </div>

            <div className="boxbuttonsdispleyprev">
              <div className="boxbuttonpersonprev">
                <input
                  type="file"
                  id="MonotaxCertificateInput"
                  ref={inputRefs.MonotaxCertificate}
                  onChange={(event) =>
                    handleFileChange(event, setMonotaxCertificate)
                  }
                  style={{ display: "none" }}
                />

                <button
                  className="boxinputprevarchive"
                  onClick={() => inputRefs.MonotaxCertificate.current.click()}
                >
                  <TbCloudUpload className="iconbuttonarchiveprev" />
                  <span>Constancia Monotributo</span>
                </button>

                {MonotaxCertificate && (
                  <div className="namefiledprov">
                    <p className="buttonprevtextarchivedelete">
                      {MonotaxCertificate.name}
                    </p>
                    <button
                      className="buttondeletearchive"
                      onClick={() => removeFile(setMonotaxCertificate)}
                    >
                      <FaTrash />
                    </button>
                  </div>
                )}
              </div>

              <div className="boxbuttonpersonprev">
                <input
                  type="file"
                  id="CBUCertificateInput"
                  ref={inputRefs.CBUCertificate}
                  onChange={(event) =>
                    handleFileChange(event, setCBUCertificate)
                  }
                  style={{ display: "none" }}
                />

                <button
                  className="boxinputprevarchive"
                  onClick={() => inputRefs.CBUCertificate.current.click()}
                >
                  <TbCloudUpload className="iconbuttonarchiveprev" />
                  <span>Constancia CBU</span>
                </button>

                {CBUCertificate && (
                  <div className="namefiledprov">
                    <p className="buttonprevtextarchivedelete">
                      {CBUCertificate.name}
                    </p>
                    <button
                      className="buttondeletearchive"
                      onClick={() => removeFile(setCBUCertificate)}
                    >
                      <FaTrash />
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="boxButtonprov" style={{ textAlign: "center" }}>
            {isUploading ? (
              <div className="loaderlitte"></div>
            ) : (
              <button
                onClick={handleUpload}
                className="buttonprovprofile"
                style={{ cursor: "pointer" }}
              >
                Subir archivos
              </button>
            )}
          </div>
        </div>
      ) : (
        <div className="loader"></div>
      )}
    </>
  );
};

export default Provdocumentation;
